import { Delete, Edit } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import CardBox from '@src/App/Components/Cards/CardBox/CardBox';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import type { AppState } from '@store/store';
import React from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './CertificateCard.css';
import { CertificateDialog } from '@src/App/Components/Dialogs/CertificateDialog/CertificateDialog';
import ExpandableText from '@src/App/Components/General/ExpandableText/ExpandableText';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';
import type Certificate from '@src/Objects/Certificate';

interface CertificateCardProps {
    certificate: Certificate;
    selected?: boolean;
    onSelectChange?: (state: boolean) => void;
}

/**
 * CertificateCard component.
 *
 * @param {CertificateCardProps} props - The props for the CertificateCard component.
 *
 * @returns {JSX.Element} The rendered CertificateCard component.
 */
function CertificateCard(props: CertificateCardProps) {
    const { openDialog } = useDialog();

    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).certificates;
    const navigate = useNavigate();
    const certificate = props.certificate;
    return (
        <CardBox
            menu={
                <div>
                    <MenuItem
                        onClick={() => {
                            openDialog(<CertificateDialog id="CertificateDialog" certificate={certificate} />);
                        }}
                    >
                        <ListItemIcon>
                            <Edit />
                        </ListItemIcon>
                        <ListItemText>{langStrings.edit}</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            certificate.delete();
                        }}
                    >
                        <ListItemIcon>
                            <Delete />
                        </ListItemIcon>
                        <ListItemText>{langStrings.delete}</ListItemText>
                    </MenuItem>
                </div>
            }
            onSelectChange={props.onSelectChange}
            selected={props.selected}
            title={certificate.title}
            className={'certificateCard'}
            onClick={() => {
                navigate(`${certificate.link}`);
            }}
        >
            <ExpandableText>
                <>
                    {langStrings.description + ': '}
                    <FormatedTextInput value={certificate.description} readonly={true} />
                </>
            </ExpandableText>
        </CardBox>
    );
}

export default CertificateCard;
